const data = {
    terminal: state => state.data.terminal,
    loginName: state => state.data.loginName,
    dataInfo: state => state.data.dataInfo,
    dataListTable: state => state.data.dataListTable,
    language: state => state.data.language,
    Categories: state => state.data.Categories,
    sortVal: state => state.data.sortVal,
    token: token => state.data.token,
}
export default data  //显示隐藏header
